import baseService from './baseService';

export function addAudioAssetFile(body) {
  return baseService.post('/assets/file/audio', body);
}

export function getAudioAssetFile(id) {
  return baseService.get(`/assets/file/audio/${id}`);
}

export function getAudioFilesBySearch(search) {
  return baseService.get(`/assets/file/search/audio/${search}`);
}

export function addClipAssetFile(body) {
  return baseService.post('/assets/file/clip', body);
}

export function getClipAssetFile(id) {
  return baseService.get(`/assets/file/clip/${id}`);
}

export function getClipFilesBySearch(search) {
  return baseService.get(`/assets/file/search/clip/${search}`);
}

export function editAssetFile(data) {
  return baseService.put('/assets/file', data);
}

export function deleteAssetFile(id) {
  return baseService.delete(`/assets/file/${id}`);
}

export function addAudioFolder(body) {
	return baseService.post('/assets/folder/audio', body);
}

export function geAssetFolderByID(ID, type) {
	return baseService.get(`/assets/folder/${type}/ID/${ID}`);
}

export function getAudioFolders(parent) {
	return baseService.get(`/assets/folder/audio/${parent}`);
}

export function addClipFolder(body) {
	return baseService.post('/assets/folder/clip', body);
}

export function getClipFolder(parent) {
	return baseService.get(`/assets/folder/clip/${parent}`);
}

export function editFolder(data) {
	return baseService.put('/assets/folder', data);
}

export function removeFolder(folders) {
	return baseService.put('/assets/folder/delete', { folders });
}
